// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"3570c2d6","75":"0775318e","172":"33214c97","235":"2ad89184","321":"0bdbbe3a","365":"d64f6bf9","398":"3a99bfa6","522":"daa6c609","654":"aee2a384","760":"97a29c7c","966":"1934931b","981":"63580a3b"}[chunkId] + ".chunk.js";
};